import React from 'react'
import { useHistory } from 'react-router'

import { BACKEND_IP } from '../../utils/const'

import './CatCardGalery.scss'

export const CatCardGalery = ({ id, routeTo, onClick }) => {
  const history = useHistory()

  const _onClick = () => {
    if (onClick) onClick()

    history.replace({ pathname : `${ routeTo }/${ id }` })
  }

  return (
    <button
      className="cat-card-galery"
      onClick={ _onClick }
    >
      <div className="img-container">
        <img
          src={`${ BACKEND_IP }/img/${ id }.jpg`}
          alt="cat"
        />
      </div>
      <div className="desc">
        <span className="title">
          TRONCOOLCATS NFT
        </span>
        <span className="subtitle">
          TCC # { id }
        </span>
      </div>
    </button>
  )
}